import styled from 'styled-components';

export const OverlayContainer = styled.div`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ImageContainer = styled.div`
  position: relative;
  max-width: 90%;
  max-height: 90%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Image = styled.img`
  max-width: 100%;
  max-height: 62vh;
  margin-top: 5vh;
  object-fit: cover;
`;

export const ArrowButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${(props) => props.position}: -72px;
  background: rgba(0, 0, 0, 0.1);
  color: white;
  border: none;
  border-radius: 50%;
  padding: 10px;
  cursor: pointer;

  &:hover {
    background: rgba(0, 0, 0, 0.6);
  }
`;

export const TopBar = styled.div`
  position: absolute;
  top: 10px;
  left: 20px;
  right: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
`;

export const ImageName = styled.div`
  color: black;
  font-weight: bold;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
`;

export const ActionButton = styled.button`
  background: #7f4bf1;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background: #6e40d8;
  }
`;

export const OverlayWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const OverlayContent = styled.div`
  position: relative;
  width: 80%;
  height: 80%;
  background: red;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
`;
